// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/projectRoute.test.tsx
// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";

import { AskV2ProjectPage } from "../pages/AskV2ProjectPage";

export type AskV2ProjectSearch = {
  /** An open item to pick up in the project's composer, from the home "For you" panel. */
  openItem?: string;
  tab?: "feed";
};

export function parseAskV2ProjectSearch(
  search: Record<string, unknown>,
): AskV2ProjectSearch {
  const openItem =
    typeof search.openItem === "string" && search.openItem.trim()
      ? search.openItem.trim()
      : undefined;
  return {
    ...(openItem ? { openItem } : {}),
    ...(search.tab === "feed" ? { tab: "feed" as const } : {}),
  };
}

export const askV2ProjectRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt/projects/$projectId",
  validateSearch: parseAskV2ProjectSearch,
  component: AskV2ProjectRoutePage,
});

function AskV2ProjectRoutePage() {
  const { projectId } = askV2ProjectRoute.useParams();
  const { openItem } = askV2ProjectRoute.useSearch();
  // why: same remount key as chatRoute — without it useAskV2Transport keeps the previous project's snapshot across param changes
  return (
    <AskV2ProjectPage
      key={projectId}
      projectId={projectId}
      openItemId={openItem}
    />
  );
}
